import Vue from "vue";
import VueRouter from "vue-router";
import beforeEach from "./beforeEach";
import Main from "../modules/main/Main.vue";
import Auth from "../modules/auth/Auth.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: { name: "Home" },
  },
  {
    path: "/",
    name: "Main",
    redirect: { name: "Home" },
    component: Main,
    children: [
      {
        path: "home",
        name: "Home",
        meta: { requiresAuth: true },
        component: () => import("@/modules/main/views/home/Home.vue"),
      },
    ],
  },
  {
    path: "/auth",
    name: "Auth",
    redirect: { name: "SignIn" },
    component: Auth,
    children: [
      {
        path: "sign-in",
        name: "SignIn",
        meta: { title: "Entrar", preventAuth: true },
        component: () => import("@/modules/auth/views/signIn/SignIn.vue"),
      },
      {
        path: "sign-up",
        name: "SignUp",
        meta: { title: "Criar Conta", preventAuth: true },
        component: () => import("@/modules/auth/views/signUp/SignUp.vue"),
      },
    ],
  },
  {
    path: "*",
    redirect: { name: "Home" },
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach(beforeEach);

export default router;
